import type { EmsComponents, NormalizedNullableResponse } from '../../api/ems';
import { normalizeNullable } from './normalizeNullable';

export type LocationSource = NonNullable<EmsComponents['schemas']['LocationSource']>;

type Sourced<T> = Omit<T, 'source'> & { source: LocationSource };

export type LocationKnown = Sourced<
  NormalizedNullableResponse<EmsComponents['schemas']['LocationLocationKnown']>
>;

export type LocationMeasured = Sourced<
  NormalizedNullableResponse<EmsComponents['schemas']['LocationLocationMeasured']>
>;

export type LocationRedacted = Sourced<
  NormalizedNullableResponse<EmsComponents['schemas']['LocationLocationRedacted']>
>;

export type Location = LocationKnown | LocationMeasured | LocationRedacted;
export type CoordinateLocation = LocationKnown | LocationMeasured;

export function isCoordinateLocation(location: Location): location is CoordinateLocation {
  return location.type === 'Known' || location.type === 'Measured';
}

export function isMeasuredLocation(location: Location): location is LocationMeasured {
  return location.type === 'Measured';
}

export function normalizeLocation(location: EmsComponents['schemas']['Location']): Location {
  return normalizeNullable(location) as Location;
}

type ExactlyTheUnion<TUnion extends string> = { [TMember in TUnion]: TMember };

export const LocationSource = {
  Entered: 'Entered',
  MobileApp: 'MobileApp',
  WebApp: 'WebApp',
  AppleEed: 'AppleEed',
  Aml: 'Aml',
  GoogleEls: 'GoogleEls',
  MobileAppSms: 'MobileAppSms',
} as const satisfies ExactlyTheUnion<LocationSource>;
